module.exports = __webpack_public_path__ + "img/sarah-andersen.fb2ba05e.png";